import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Loader } from "react-overlay-loader";
import Routes from "./Router/routes";
import CongratulationsModal from "./components/modal";
import { useLoader } from "./context/LoaderContext";
import "./App.css";
import "./style.css";

function App() {
  const { loader } = useLoader();

  return (
    <>
      {loader && <Loader fullPage loading />}
      <CongratulationsModal />
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </>
  );
}

export default App;
